import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { formatPercentage } from '../../../packages/utils/numberFormatters'

export function ConditionalIssueRow({ issue }: { issue: Partial<IssueEntity> }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language

    if (issue.minimumSubCondition === null) {
        return null
    }

    const minimumSubCondition = formatPercentage(issue.minimumSubCondition!, { minDecimals: 0, maxDecimals: 2, locale })

    return (
        <FactsTableRow label={t('pages.issues.terms.conditionalSubscriptionRate')}>
            <Typography>
                {t('pages.issues.terms.conditionalIssueText', { rate: minimumSubCondition })}
            </Typography>
        </FactsTableRow>
    )
}
